
<template>
    <v-container fluid class="px-0 pb-0" v-resize="myEventHandler">
        <div flat>
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Gestión de Trámites
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            Gestión de Trámites
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                        <!-- <v-progress-circular
                            width="2"
                            v-if="tariffManagement.isLoading"
                            :size="30"
                            color="black"
                            indeterminate
                        ></v-progress-circular> -->
                        <v-btn
                            @click="openAddingForm()"
                            color="green"
                            class="mr-2"
                            :small="$vuetify.breakpoint.mdAndDown"
                            text
                        >
                            Nuevo Trámite
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                :height="tableHeight"
                :headers="headers"
                :items="procedures"
                :loading="loadingItems"
                :items-per-page="footerProps.itemsPerPageOptions"
                :search="search"
                class="px-2"
            >
                <template v-slot:item.is_active="{ item }">
                    <v-icon :color="item.is_active ? 'green' : 'red'">
                        mdi-circle
                    </v-icon>
                </template>
                <template v-slot:item.Actions="{ item }">
                    <v-row>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                x-small
                                color="primary"
                                text
                                @click="watchingForm(item)"
                            >
                                <v-icon> mdi-information-slab-box </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                x-small
                                color="orange"
                                text
                                @click="editingForm(item)"
                            >
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="2" v-if="hasSuperAdminPermission">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                x-small
                                color="red"
                                text
                                @click="openConfirmdelete(item)"
                            >
                                <v-icon> mdi-delete-empty-outline </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </div>
    </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'procedureManagementTable',

    data: () => ({
        tableHeight: 300,
        footerProps: {
            itemsPerPageOptions: [10],
        },
        headers: [
            { text: 'Nombre', value: 'name' },
            { text: 'Operador', value: 'operator' },
            { text: 'Tipo', value: 'tipo_gestion' },
            { text: 'Activa', value: 'is_active', sortable: true },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '150px',
            },
        ],
    }),
    methods: {
        setForm(item) {
            this.$store.state.ManagementBase.procedureManagement.IsActive =
                item.is_active;
            this.$store.state.ManagementBase.procedureManagement.Name =
                item.name;
            this.$store.state.ManagementBase.procedureManagement.Operator =
                item.operator;
            this.$store.state.ManagementBase.procedureManagement.Type =
                item.tipo_gestion;
            this.$store.state.ManagementBase.procedureManagement.editingId =
                item.id;
        },
        closeOtherForms() {
            this.$store.state.insuranceManagement.isOpenDialog = false;
            this.$store.state.dboriginManagement.isOpenDialog = false;
        },
        openAddingForm() {
            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'ADMINISTRATION';
            this.$store.state.ManagementBase.baseForm.formType = 'add';
            this.$store.state.ManagementBase.baseForm.isActive = true;
        },
        openConfirmdelete(item) {
            let deleteData = {
                module: 'ManagementBase/procedureManagement',
                item: item,
            };

            this.$store.commit('ManagementBase/confirmDeletion', {
                val: true,
                deleteData,
            });
        },
        watchingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'ADMINISTRATION';
            this.$store.state.ManagementBase.baseForm.formType = 'watch';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        editingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'ADMINISTRATION';
            this.$store.state.ManagementBase.baseForm.formType = 'edit';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        determineWidth() {
            let width = window.innerWidth;
            let height = 0;
            if (this.$vuetify.breakpoint.smAndDown) {
                height = 294;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                height = 234;
            } else {
                if (width < 1661) {
                    height = 258;
                } else {
                    height = 242;
                }
            }
            return height + 62;
        },
        myEventHandler() {
            // Get width of the window
            this.tableHeight =
                document.getElementById('fullHeigth')?.clientHeight -
                this.determineWidth();
        },
    },
    computed: {
        ...mapState('ManagementBase/procedureManagement', {
            procedures: (state) => state.procedures,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
        ...mapState('ManagementBase', {
            tipoObjetivo: (state) => state.tipoObjetivo,
        }),
        ...mapState('ManagementBase', {
            loadingItems: (state) => state.loadingItems,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    watch: {
        tableHeight() {
            this.footerProps.itemsPerPageOptions = Math.floor(
                this.tableHeight / 48 - 1
            );
        },
    },
};
</script>

<style>
</style>